define(["../occurrenceStatusModule",
        "json!../../monitoring.json",
        "json!../../tdnByEntity.json"],
    function (occurrenceStatusModule, monitoring, tdnByEntity) {
        "use strict";

        return occurrenceStatusModule.controller("OccurrenceStatusSearchController", [
            "$scope",
            "$q",
            "monitoringService",
            "reload",
            "loadingService",
            "remoteExceptionHandler",
            "occurrenceStatusService",
            "tdnHelp",
            function ($scope, $q, monitoringService, reload, loadingService, remoteExceptionHandler, occurrenceStatusService, tdnHelp) {
                $scope.serviceName = monitoring.services.occurrenceStatusFilter;
                var template, paginationApi, paginationApiDefer = $q.defer();
                var filterApi, filterApiDefer = $q.defer();

                $scope.tdn = tdnByEntity?.[tdnHelp.getContext()]?.["occurrence-status"]

                $scope.search = function (modifiedTemplate) {
                    template = modifiedTemplate;
                    paginationApi.seekPage(1);
                };

                $scope.onRegisterFilterApi = function (api) {
                    filterApi = api;
                    filterApiDefer.resolve();
                };

                $q.all([paginationApiDefer.promise, filterApiDefer.promise]).then(function () {
                    filterApi.onChangeService(function (service) {
                        if (service === $scope.serviceName) {
                            if (reload) {
                                filterApi.reload();
                            } else {
                                filterApi.reset();
                            }
                        }
                    });
                });

                $scope.tableOptions = {
                    records: [],
                    pagination: {
                        onPaginate: function (firstResult, maxResults) {
                            return loadingService(monitoringService.filterOccurrenceStatus("/filter", template, firstResult, maxResults))
                                .then(function (result) {
                                    return result;
                                }).catch(remoteExceptionHandler());
                        }
                    },
                    onRegisterPagination: function (api) {
                        paginationApi = api;
                        paginationApiDefer.resolve();
                    }
                };

                $scope.delete = function (id) {
                    return occurrenceStatusService.deleteOccurrenceStatus(id)
                        .finally(function () {
                            filterApi.reload();
                        });
                };
            }]);
    });